// extracted by mini-css-extract-plugin
module.exports = {"gist-resizer-row":"gist-frame_gist-resizer-row__X6Bpg","gist-resizer":"gist-frame_gist-resizer__W5Htv"};